import { CompanyCreateData, CompanyUpdateData, GatewayCreateData, GatewayUpdateData, SensorCreateData, SensorUpdateData, UserCreateData, UserUpdateData, CopernicusQueryPayload, TriggerAllSatellitesPayload } from "../redux/reducers/clients/clients.types";
import apiClient from "./api";

export const getSectorData = async () => {
    return await apiClient.get(`/api/admin/sector`);
};
export const getMainSectorData = async () => {
    return await apiClient.get(`/api/admin/main-sector`);
};

export const getBasins = async () => {
    return await apiClient.get(`/api/admin/basin/`);
};

export const getWaterAdministrationData = async () => {
    return await apiClient.get(`/api/admin/water-administration/`);
};

export const getSubscriptionData = async (administrationId: number) => {
    return await apiClient.get(`/api/admin/water-administration/${administrationId}`);
};
export const getCompanyList = async () => {
    return await apiClient.get(`/api/admin/company/list`);
};

export const getCompanyById = async (companyId: string) => {
    return await apiClient.get(`/api/admin/company/get-by-id/${companyId}`);
};

export const updateCompany = async (companyId: string, companyData: CompanyUpdateData) => {
    return await apiClient.put(`/api/admin/company/`, { ...companyData, id: companyId });
};

export const getAllCompanies = async () => {
    return await apiClient.get(`/api/admin/company/all`);
};

export const getCompanyTypes = async () => {
    return await apiClient.get(`/api/admin/company-type/`);
};

export const getCountries = async () => {
    return await apiClient.get(`/api/admin/country/`);
};

export const getCities = async (countryId: number) => {
    return await apiClient.get(`/api/admin/city/${countryId}`);
};

export const getDistricts = async (cityId: number) => {
    return await apiClient.get(`/api/admin/district/${cityId}`);
};

export const createCompany = async (companyData: CompanyCreateData) => {
    return await apiClient.post(`/api/admin/company/`, companyData);
};

export const getProductFamilyTree = async () => {
    return await apiClient.get(`/api/admin/product-family/`);
};

// --- USER MANAGEMENT SERVICES ---

/**
 * Fetches all users from the backend.
 */
export const getAllUsers = async (companyId: string) => {
    return await apiClient.get(`/api/admin/user-management/company/${companyId}`);
};

/**
 * Fetches a list of all available user roles.
 */
export const getUserRoles = async () => {
    return await apiClient.get(`/api/admin/user-management/roles/list`);
};

/**
 * Creates a new user for a specific company.
 */
export const createUser = async (companyId: string, userData: UserCreateData) => {
    return await apiClient.post(`/api/admin/user-management/company/${companyId}`, userData);
};

/**
 * Fetches all users belonging to a specific company.
 */
export const getUsersByCompanyId = async (companyId: string) => {
    return await apiClient.get(`/api/admin/user-management/company/${companyId}`);
};

export const getUserById = async (userId: string) => {
    return await apiClient.get(`/api/admin/user-management/${userId}`);
};

export const updateUser = async (userId: string, userData: UserUpdateData) => {
    return await apiClient.put(`/api/admin/user-management/${userId}`, userData);
};

export const getGatewaysByCompanyId = async (companyId: string) => {
    return await apiClient.get(`/api/admin/gateway/company/${companyId}`);
};

export const createGateway = async (companyId: string, gatewayData: GatewayCreateData) => {
    return await apiClient.post(`/api/admin/gateway/`, { ...gatewayData, companyId });
};

export const updateGateway = async (gatewayId: string, gatewayData: GatewayUpdateData) => {
    return await apiClient.put(`/api/admin/gateway/${gatewayId}`, gatewayData);
};

export const deleteGateway = async (gatewayId: string) => {
    return await apiClient.delete(`/api/admin/gateway/${gatewayId}`);
};

export const getSensorsByCompanyId = async (companyId: string) => {
    return await apiClient.get(`/api/admin/sensor/company/${companyId}`);
};

export const createSensor = async (sensorData: SensorCreateData) => {
    return await apiClient.post(`/api/admin/sensor/`, sensorData);
};

export const updateSensor = async (sensorId: string, sensorData: SensorUpdateData) => {
    return await apiClient.put(`/api/admin/sensor/${sensorId}`, sensorData);
};

export const deleteSensor = async (sensorId: string) => {
    return await apiClient.delete(`/api/admin/sensor/${sensorId}`);
};

export const getWaterAdministrationMainSectorData = async (administrationId: number) => {
    return await apiClient.get(`/api/admin/water-administration-sectors/main/${administrationId}`);
}

export const getWaterAdministrationSubSectorData = async (administrationId: number) => {
    return await apiClient.get(`/api/admin/water-administration-sectors/sub/${administrationId}`);
}

export const executeCopernicusQuery = async (payload: CopernicusQueryPayload) => {
    return await apiClient.post(`/api/admin/climateDataset/copernicus/query`, payload);
};

export const getClimateDatasets = async () => {
    return await apiClient.get(`/api/admin/climateDataset/copernicus`);
};

export const getClimateDatasetById = async (datasetId: string) => {
    return await apiClient.get(`/api/admin/climateDataset/copernicus/${datasetId}`);
};

import { GldasQueryPayload, GraceQueryPayload } from "../redux/reducers/clients/clients.types";

export const executeGldasQuery = async (payload: GldasQueryPayload) => {
    return await apiClient.post(`/api/admin/gldas/query`, payload);
};

export const executeGraceQuery = async (payload: GraceQueryPayload) => {
    return await apiClient.post(`/api/admin/grace/query`, payload);
};

export const triggerAllSatelliteQueries = async (payload: TriggerAllSatellitesPayload) => {
    return await apiClient.post(`/api/admin/climateDataset/trigger-all`, payload);
};

export const checkSatelliteSyncStatus = async (companyId: string) => {
    return await apiClient.get(`/api/admin/climateDataset/sync-status/${companyId}`);
};